/**
 * 数据分析模块模拟数据
 * 用于在后端API未就绪时提供模拟数据
 */

// 生成随机数
const random = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// 生成日期数组（最近N天）
const generateDates = (days) => {
  const dates = [];
  for (let i = days - 1; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(`${date.getMonth() + 1}/${date.getDate()}`);
  }
  return dates;
};

// 车辆分析模拟数据
export const vehicleAnalysisMock = {
  // 统计数据
  getStats() {
    return {
      code: 1,
      data: {
        vehicleNum: random(80, 150),
        vehicleOnlineNum: random(50, 100),
        vehicleRunningNum: random(30, 60),
        vehicleIdleNum: random(10, 30)
      }
    };
  },
  
  // 车辆列表
  getVehicleList() {
    const vehicles = [];
    const statuses = ['running', 'idle', 'offline'];
    const lines = ['成都-重庆', '成都-绵阳', '成都-乐山', '成都-德阳', '成都-眉山'];
    
    for (let i = 1; i <= 20; i++) {
      vehicles.push({
        id: i,
        plateNumber: `川A${String(random(10000, 99999))}`,
        driverName: `司机${i}`,
        driverId: 1000 + i,
        lineName: lines[random(0, lines.length - 1)],
        onlineStatus: random(0, 1),
        runningStatus: random(0, 1),
        longitude: 104.0668 + (Math.random() - 0.5) * 0.2,
        latitude: 30.5728 + (Math.random() - 0.5) * 0.2,
        updateTime: new Date().toLocaleTimeString()
      });
    }
    
    return {
      code: 1,
      data: { list: vehicles }
    };
  },
  
  // 出勤趋势
  getAttendanceTrend() {
    const dates = generateDates(7);
    return {
      code: 1,
      data: {
        statisticsReportVos: dates.map(date => ({
          date,
          vehicleOnlineNum: random(40, 80),
          vehicleRunningNum: random(20, 50)
        }))
      }
    };
  },
  
  // 车辆类型分布
  getVehicleType() {
    return {
      code: 1,
      data: [
        { name: '7座商务车', value: random(20, 40) },
        { name: '9座商务车', value: random(15, 30) },
        { name: '17座中巴', value: random(10, 25) },
        { name: '33座大巴', value: random(5, 15) },
        { name: '45座大巴', value: random(3, 10) }
      ]
    };
  }
};

// 订单分析模拟数据
export const orderAnalysisMock = {
  // 统计数据
  getStats() {
    return {
      code: 1,
      data: {
        orderCreateNum: random(500, 1500),
        orderFinishNum: random(400, 1200),
        orderPayNum: random(50, 200),
        orderRefundNum: random(10, 50),
        orderPayAmount: random(50000, 200000),
        passengerNum: random(800, 3000)
      }
    };
  },
  
  // 订单趋势
  getTrendData() {
    const dates = generateDates(7);
    return {
      code: 1,
      data: {
        statisticsReportVos: dates.map(date => ({
          date,
          orderCreateNum: random(50, 200),
          orderFinishNum: random(40, 180),
          orderPayAmount: random(5000, 30000)
        }))
      }
    };
  },
  
  // 订单状态分布
  getStatusData() {
    return {
      code: 1,
      data: [
        { name: '已完成', value: random(300, 600) },
        { name: '进行中', value: random(50, 150) },
        { name: '待支付', value: random(20, 80) },
        { name: '已取消', value: random(10, 50) },
        { name: '已退款', value: random(5, 30) }
      ]
    };
  },
  
  // 订单来源分布
  getSourceData() {
    return {
      code: 1,
      data: [
        { name: '小程序', value: random(200, 500) },
        { name: 'APP', value: random(100, 300) },
        { name: '公众号', value: random(50, 150) },
        { name: '平台下单', value: random(30, 100) },
        { name: '渠道推广', value: random(20, 80) }
      ]
    };
  },
  
  // 热门线路排行
  getLineRank() {
    return {
      code: 1,
      data: [
        { lineName: '成都-重庆', orderNum: random(100, 300) },
        { lineName: '成都-绵阳', orderNum: random(80, 200) },
        { lineName: '成都-乐山', orderNum: random(60, 150) },
        { lineName: '成都-德阳', orderNum: random(40, 120) },
        { lineName: '成都-眉山', orderNum: random(30, 100) }
      ]
    };
  },
  
  // 订单时段分布
  getHourDist() {
    const hours = [];
    for (let i = 6; i <= 22; i++) {
      hours.push({
        hour: `${i}:00`,
        orderNum: random(10, 100)
      });
    }
    return {
      code: 1,
      data: hours
    };
  }
};

export default {
  vehicleAnalysisMock,
  orderAnalysisMock
};
